const Mobile = () => {
  return (
    <main className="main__content">
      <section className="main__container-app">
        <h2>
          برای کار کردن با اپلیکیشن در حال توسعه از طریق Expo اقدام کنید .
        </h2>
        <h3>اپلیکیشن Expo را از طریق لینک زیر دانلود نمایید .</h3>

        <a href="https://play.google.com/store/apps/details?id=host.exp.exponent">
          https://play.google.com/store/apps/details?id=host.exp.exponent
        </a>
        <h3>
          پس از نصب و بازکردن اپلیکیشن Expo از طریق آن ، QR Code زیر را اسکن
          کنید .
        </h3>
        <img src="/img/qr-code.svg" alt="" />
        <h4>
          بعد از اسکن QR Code اپلیکیشن به صورت اتوماتیک برای شما باز می شود .
        </h4>
      </section>
    </main>
  );
};

export default Mobile;
